<nav aria-label="breadcrumb" role="navigation">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
    <li class="breadcrumb-item" aria-current="page"><a routerLink="/usati">Elenco usati</a></li>
    <li class="breadcrumb-item active" aria-current="page">Scheda usato</li>
  </ol>
</nav>

<div class="row" style="min-height: 950px;" *ngIf="!pratica">
  <div class="col-lg-12 text-center">
    <h1>Pratica in aggiornamento, riprovare più tardi o contattare Orion</h1>
  </div>
</div>


<div class="card" *ngIf="pratica">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-6">
        <h4 class="card-title">Dettaglio pratica ({{pratica.vclPratica}}) <span
          *ngIf="pratica.vclTipologia != '' || pratica.vclcntVclTipo != ''">{{pratica.vclTipologia}} {{pratica.vclcntVclTipo}}
          -</span>
          Anno: {{pratica.vclDataImmatr | date:'yyyy'}}</h4>
      </div>
      <div class="col-lg-6">
        <button class="btn btn-outline-primary contattaci float-right" (click)="stampa()"><i class="fa fa-print" aria-hidden="true"></i> Stampa scheda</button>
        <button class="btn btn-outline-primary contattaci float-right" (click)="share()" *ngIf="newVariable && newVariable.share"><i class="fa fa-share-alt" aria-hidden="true"></i> Condividi</button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <ngx-gallery [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-12">
            <b style="color: #32306f;">{{pratica.vclTipologia}} {{pratica.vclcntVclTipo}}
              - {{pratica.vclDataImmatr | date:'yyyy'}}</b>
          </div>
        </div>
        <div class="row voci" *ngIf="loggato">
          <div class="col-lg-6">
            Prezzo
          </div>
          <div class="col-lg-6">
            <span style="font-weight: bold; color: red;">{{pratica.vclUsatoValoreVendita | currency:'EUR':'symbol'}}</span>
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Km percorsi
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclKmPercorsi}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Marca
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclMarca}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Modello
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclMod}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Versione
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclVersione}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Carrozzeria
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclCarrozzeria}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Alimentazione
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclAliment}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Data immatr.
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclDataImmatr | date:'dd/MM/yyyy'}}
          </div>
        </div>

        <div class="row voci">
          <div class="col-lg-4 col-6">
            Data revisione
          </div>
          <div class="col-lg-8 col-6">
            {{pratica.vclRev | date:'dd/MM/yyyy'}}
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-lg-6">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>Accessori veicolo</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of pratica.accessoriVeicolo">
                <td>{{row.VclUsatoAccVclAccessorio}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>Accessori allestimento</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of pratica.accessoriAllestimento">
                <td>{{row.VclUsatoAccAll}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>      
      </div>
    </div>
  </div>
</div>

